/**
 * Palettes for avatar circles (background, border, text). Same string always
 * maps to the same palette so avatars are consistent across the app.
 */
export const AVATAR_COLOR_PALETTES = [
  {
    bg: "bg-green-100 dark:bg-green-500/20",
    border: "border-green-300 dark:border-green-500/40",
    text: "text-green-700 dark:text-green-200",
  },
  {
    bg: "bg-amber-100 dark:bg-amber-500/20",
    border: "border-amber-300 dark:border-amber-500/40",
    text: "text-amber-700 dark:text-amber-200",
  },
  {
    bg: "bg-blue-100 dark:bg-blue-500/20",
    border: "border-blue-300 dark:border-blue-500/40",
    text: "text-blue-700 dark:text-blue-200",
  },
  {
    bg: "bg-rose-100 dark:bg-rose-500/20",
    border: "border-rose-300 dark:border-rose-500/40",
    text: "text-rose-700 dark:text-rose-200",
  },
  {
    bg: "bg-violet-100 dark:bg-violet-500/20",
    border: "border-violet-300 dark:border-violet-500/40",
    text: "text-violet-700 dark:text-violet-200",
  },
  {
    bg: "bg-teal-100 dark:bg-teal-500/20",
    border: "border-teal-300 dark:border-teal-500/40",
    text: "text-teal-700 dark:text-teal-200",
  },
  {
    bg: "bg-sky-100 dark:bg-sky-500/20",
    border: "border-sky-300 dark:border-sky-500/40",
    text: "text-sky-700 dark:text-sky-200",
  },
  {
    bg: "bg-emerald-100 dark:bg-emerald-500/20",
    border: "border-emerald-300 dark:border-emerald-500/40",
    text: "text-emerald-700 dark:text-emerald-200",
  },
] as const;

/**
 * Returns a stable palette index for the given string (e.g. user name or id).
 * Same string always returns the same index so avatars are consistent.
 */
function hashStringToIndex(str: string): number {
  if (!str.trim()) return 0;
  const sum = str.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return Math.abs(sum) % AVATAR_COLOR_PALETTES.length;
}

/**
 * Returns the avatar color palette (bg, border, text classes) for the given
 * string. Reusable anywhere you need deterministic colors per user/entity.
 */
export function getAvatarColorsForString(str: string): (typeof AVATAR_COLOR_PALETTES)[number] {
  return AVATAR_COLOR_PALETTES[hashStringToIndex(str)];
}
